module.exports = __webpack_public_path__ + "img/project9_11.png.1b70d505.webp";